import moment from 'moment'
import {orderBy, partial} from 'external/lodash'
import {useContext} from 'external/react'
import Student from 'context/student-context'

export default function useStudent () {
  const {state, update} = useContext(Student.Context)
  const {events, eventCategories, eventsByDay, teachers, courses = {}, assignments, assignedContent = [], gradesContent = [], recentActivity = [], messages, messagesSource, messagesSources} = state
  const groups = orderBy(Object.values(courses || {}), ['course']).map(group => ({...group, teachers: group.teachers.map(id => teachers[id])}))
  const has = (properties, test = i => i != undefined) => properties.every(name => test(state[name]))

  const [contentCount = {}, content = []] = assignedContent
  const [gradesCount = {}, grades = []] = gradesContent

  const teacherGroups = Object.entries(teachers || {}).reduce((acc, [passport, teacher]) => {
    const {teacherGroups: groups = []} = teacher
    return {...acc, ...groups.reduce((acc, group) => ({...acc, [group]:passport}),{})}
  }, {})
  const getTeacherPassport = group => teacherGroups[group]

  const date = getDate(state.props.query)

  return {
    events,
    eventCategories,
    eventsByDay,
    date,
    getTeacherPassport,
    teachers,
    courses,
    assignments,
    update,
    groups,
    has,
    contentCount,
    content: content == null ? [] : content,
    gradesCount,
    grades: grades == null ? [] : grades,
    recentActivity: recentActivity == null ? [] : recentActivity,
    messages,
    messagesSource,
    messagesSources,
  }
}

function getTime(date) {
  return moment(date).toDate().getTime()
}

function getDate ({start, end}) {
  const time = (getTime(start) + getTime(end)) / 2
  return partial(moment, time)
}
